import { render, staticRenderFns } from "./Kontragentpos.vue?vue&type=template&id=632a92c3&scoped=true"
import script from "./Kontragentpos.vue?vue&type=script&lang=js"
export * from "./Kontragentpos.vue?vue&type=script&lang=js"
import style0 from "./Kontragentpos.vue?vue&type=style&index=0&id=632a92c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632a92c3",
  null
  
)

export default component.exports